import { takeLatest, put } from "redux-saga/effects";
import accountSlice, { FETCH_MY_COMPANY } from "store/account/slice";
import { getMyCompany } from "resources/services/companyService";

function* fetch({ payload }) {
  const { onSuccess } = payload || {};
  const { error, fetchingMyCompany, success, setMyCompany } =
    accountSlice.actions;

  yield put(fetchingMyCompany());

  try {
    const response = yield getMyCompany();
    onSuccess && onSuccess(response);

    yield put(setMyCompany(response));
    yield put(success());
  } catch (e) {
    yield put(error(e));
  }
}

export default function* watchFetchCompany() {
  yield takeLatest(FETCH_MY_COMPANY.type, fetch);
}
